import videojs, { VideoJsPlayer } from 'video.js';

interface MetadataConfig {
  title?: string;
  metadata?: string[];
}

export function createMetadataDisplay(
  playerRef: VideoJsPlayer,
  config: MetadataConfig = {}
) {
  const player = playerRef;
  const videoEl = player && player.el();

  if (!videoEl) {
    return;
  }

  // Create metadata container
  const metadataContainer = document.createElement('div');
  metadataContainer.className = 'vjs-metadata-display';
  metadataContainer.setAttribute('data-testid', 'metadata-display');

  // Create title element
  const titleElement = document.createElement('div');
  titleElement.className = 'vjs-metadata-title';
  titleElement.textContent = config.title || '';
  metadataContainer.appendChild(titleElement);

  // Create metadata info element
  const metadataInfo = document.createElement('div');
  metadataInfo.className = 'vjs-metadata-info';

  // Add metadata items separated by dots
  const metadataItems =
    config.metadata || [''];
  metadataInfo.textContent = metadataItems.join(' • ');
  metadataContainer.appendChild(metadataInfo);

  // Add to player
  videoEl.appendChild(metadataContainer);

  // Handle fullscreen changes
  player.on('fullscreenchange', () => {
    if (player.isFullscreen()) {
      metadataContainer.style.display = 'flex';
    } else {
      metadataContainer.style.display = 'none';
    }
  });

  // Initially hide if not in fullscreen
  if (!player.isFullscreen()) {
    metadataContainer.style.display = 'none';
  }

  return metadataContainer;
}

export function updateMetadataDisplay(
  playerRef: VideoJsPlayer,
  config: MetadataConfig
) {
  const videoEl = playerRef && playerRef.el();
  if (!videoEl) {
    return;
  }

  const metadataContainer = videoEl.querySelector(
    '.vjs-metadata-display'
  ) as HTMLElement;
  if (!metadataContainer) {
    // If not found, create it
    createMetadataDisplay(playerRef, config);
    return;
  }

  // Update title
  const titleElement = metadataContainer.querySelector(
    '.vjs-metadata-title'
  ) as HTMLElement;
  if (titleElement && config.title) {
    titleElement.textContent = config.title;
  }

  // Update metadata info
  const metadataInfo = metadataContainer.querySelector(
    '.vjs-metadata-info'
  ) as HTMLElement;
  if (metadataInfo && config.metadata) {
    metadataInfo.textContent = config.metadata.join(' • ');
  }
}
